export default "__VITE_ASSET__CJt2Wdhg__"